import { createStoreModule } from '@/_core/fluxstore';
import { IAction } from '@/_core/fluxstore/types';
import { NotificationSettingsState } from './types';

const initState = () => {
    return new  NotificationSettingsState();
};

export const useNotificationSettingsStore = createStoreModule<NotificationSettingsState, IAction<NotificationSettingsState>>(initState, 'root-notification-settings');
